import { render, staticRenderFns } from "./donateDetail.vue?vue&type=template&id=6a8b4638&scoped=true&"
import script from "./donateDetail.vue?vue&type=script&lang=js&"
export * from "./donateDetail.vue?vue&type=script&lang=js&"
import style0 from "./donateDetail.vue?vue&type=style&index=0&id=6a8b4638&prod&lang=less&scoped=true&"
import style1 from "./donateDetail.vue?vue&type=style&index=1&id=6a8b4638&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b4638",
  null
  
)

export default component.exports